<div class="container">
  <!-- ----------------------------- Create DWM Text ------------------------------------------------- -->

  <ion-row>
    <ion-col size="12">
      <div class="report-Config-header">
        <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select" [(ngModel)]="selectedYearForDWM" (selectionChange)="getYearSetupForDWM(selectedYearForDWM)">
            <mat-option [value]="item.year" *ngFor="let item of pmsYears">
              {{sharedService.transformYearToFyFormat(item.year)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <span class="audit-trail mr-10" (click)="onClickAuditTrail()">Audit Trail</span>
          <!-- <span class="reportConfig" (click)="openReportConfig()">Report Config</span> -->
          <button type="button" class="add_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName" (click)="openReportConfig()">Report Config</button>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <div class="table-card-box mb-15">
    <ion-row>
      <ion-col size="12" size-md>
        <div class="phi-flex-wrap-center phi-gap-12">
          <mat-form-field class="mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchString" (input)="onSearch(searchString)" />
          </mat-form-field>

          <label class="phi-flex phi-gap-6 phi-align-items-center">
            <ion-label class="fs-14 fs_12ForMobile fs_12ForMobile font_regular black_color">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedSizeForProduct" (selectionChange)="onSelectSizeOfProduct()">
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_medium black_color">entries</ion-label>
          </label>
          <button *ngIf="isAnySelected" (click)="deleteProduct()" class="materialBtnIcon red fs-14 fs_12ForMobile font_semibold">
            <span class="material-icons fs-20">delete</span>
          </button>
        </div>
      </ion-col>
      <ion-col size="12" size-md="auto">
        <div class="phi-flex-wrap-center phi-gap-12 phi-justify-content-end">
          <button type="button" class="add_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName" (click)="addProductDialog()">+ Add New</button>
          <!-- <button class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold" (click)="downloadData()">
            <span class="material-icons">download</span>
          </button> -->
          <div class="download-btns phi-flex-wrap-center phi-gap-12">
            <img src="assets/svg/pdf.svg" class="download-img-btn" (click)="downloadReport('pdf')" />
            <img src="assets/svg/excel.svg" class="download-img-btn" (click)="downloadReport('excel')" />
          </div>
        </div>
      </ion-col>
    </ion-row>

    <!-- -------------------------- Task List Table ---------------------------- -->
    <ion-row>
      <ion-col>
        <div class="table-container">
          <table class="hover mb-15 ">
            <thead>
              <tr>
                <th class="mat-checkbox-style text-center">
                  <mat-checkbox class="custom-checkbox" (change)="selectALLRecords($event)" [(ngModel)]="selectAllCheckbox"></mat-checkbox>
                </th>
                <ng-container *ngFor="let item of headerNameForRNDTable">
                  <th class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class=" verticle-center justify-content-space-between icon-style">
                      {{ item }}

                      <div class="sort-records-container d-flex flex-column ml-5">
                        <i (click)="onSortAssending(item)" class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                        <i (click)="onSortDesending(item)" class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let product of getProductsList;let i = index">
                <tr>
                  <td class="mat-checkbox-style text-center">
                    <mat-checkbox class="custom-checkbox" [(ngModel)]="product.checkboxCheck" (change)="selectSingleRecord($event, product,i)" [disabled]="product.allowedToEditDelete"></mat-checkbox>
                  </td>

                  <td class="fs-14 fs_12ForMobile font_regular">
                    {{ product.productNo }}
                  </td>

                  <td class="fs-14 fs_12ForMobile font_regular">
                    {{ product.productName }}
                  </td>

                  <td class="fs-14 fs_12ForMobile font_regular">
                    {{ product.plantLocation }}
                  </td>

                  <td class="fs-14 fs_12ForMobile font_regular">
                    {{ product.businessUnit }}
                  </td>
                  <td class="fs-14 fs_12ForMobile font_regular">
                    {{ product.productCustomer }}
                  </td>
                  <td class="text-center">
                    <img class="ml-5 cp imgEdit" title="Edit" src="assets/icon/edit.png" (click)="editProject(product)" />
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <!-- -------------------------- Pagination ---------------------------- -->
        <ion-row class="mb-5">
          <ion-col size="12" size-md="4" class="text-left">
            <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{ endItem!==0?startItem:0 }} to {{ endItem }} of {{ totalItems }} entries</ion-label>
          </ion-col>
          <ion-col size="12" size-md="8" class="phi-justify-content-end pagination-controls">
            <div class="phi-flex-wrap-center phi-gap-12 phi-justify-content-end">
              <ul class="dt_pagination phi-flex-wrap-center phi-gap-12">
                <li class="active fs-16 fs_14ForMobile font_regular">{{totalPages!==0?currentPage+1:0}}</li>
                <span class="fs-14 fs_12ForMobile font_regular p-10">of {{totalPages}}</span>
                <li class="fs-24 fs_18ForMobile cp" (click)="changePage(currentPage - 1)" [ngClass]="{'disableBtn': currentPage === 0}">&lt;</li>
                <li class="fs-24 fs_18ForMobile cp" (click)="changePage(currentPage + 1)" [ngClass]="{'disableBtn': currentPage >= totalPages - 1}">&gt;</li>
              </ul>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </div>
</div>
